import { useResponsive } from "@sundae/react-hooks";
import { toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, memo } from "react";
import FadeInBasic from "../../components/FadeInView/FadeInBasic";

const TasteTestDetailSkeleton: FC = () => {
  const responsive = useResponsive();
  return (
    <FadeInBasic>
      <div
        className={cx(
          "mt-4 h-32 w-full rounded-tl-lg rounded-tr-lg motion-safe:animate-pulse lg:h-80",
          toolkitCx.layout.background.loading
        )}
      />

      <div className="mx-auto flex max-w-6xl flex-col gap-4 motion-safe:animate-pulse">
        <div className="-mt-8 lg:-mt-16">
          <div className={cx("h-64 rounded-lg", toolkitCx.layout.background.loading)} />
        </div>

        <div className="grid">
          <div className="relative grid w-full gap-8 lg:grid lg:grid-cols-6 xl:grid-cols-5">
            {responsive.lg ? (
              <>
                <div className="flex h-full flex-col gap-4 pt-8 lg:col-span-3">
                  {Array.from({ length: 3 }).map((_, index) => {
                    return (
                      <div
                        key={index}
                        className={cx("h-80 rounded-lg", toolkitCx.layout.background.loading)}
                      />
                    );
                  })}
                </div>

                <div className="flex h-full flex-col gap-4 pt-8 lg:col-span-3 xl:col-span-2">
                  {Array.from({ length: 1 }).map((_, index) => {
                    return (
                      <div
                        key={index}
                        className={cx(
                          "rounded-lg",
                          {
                            "h-[380px]": index === 0,
                          },
                          toolkitCx.layout.background.loading
                        )}
                      />
                    );
                  })}
                </div>
              </>
            ) : (
              <div className="flex h-full flex-col gap-4">
                {Array.from({ length: 3 }).map((_, index) => {
                  return (
                    <div
                      key={index}
                      className={cx("h-80 rounded-lg", toolkitCx.layout.background.loading)}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </FadeInBasic>
  );
};

export default memo(TasteTestDetailSkeleton);
